/*
 * decaffeinate suggestions:
 * DS001: Remove Babel/TypeScript constructor workaround
 * DS102: Remove unnecessary code created because of implicit returns
 * DS202: Simplify dynamic range loops
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let LineView;
export default (LineView = (function() {
    LineView = class LineView extends Backbone.Marionette.ItemView {
        constructor(...args) {
            super(...args);
            this.initialize = this.initialize.bind(this);
            this.onRender = this.onRender.bind(this);
        }

        static initClass() {
            this.prototype.tagName = "li";
            this.prototype.template = require("./templates/line_view");
        }

        initialize() {
            return this.listenTo(this.model, "change", this.render);
        }

        onRender() {
            let a;
            let i;
            this.$el.attr("class", this.model.get("clazz"));
            if ((a = this.model.get("atom")) != null) {
                const ci = ((() => {
                    let asc, end;
                    const result = [];
                    for (i = 1, end = a.column, asc = 1 <= end; asc ? i <= end : i >= end; asc ? i++ : i--) {
                        result.push(" ");
                    }
                    return result;
                })()).join("").substr(1) + ((() => {
                    let asc1, end1;
                    const result1 = [];
                    for (i = 1, end1 = a.len, asc1 = 1 <= end1; asc1 ? i <= end1 : i >= end1; asc1 ? i++ : i--) {
                        result1.push("^");
                    }
                    return result1;
                })()).join("");
                return this.model.set({columnIndicator: ci});
            }
        }
    };
    LineView.initClass();
    return LineView;
})());



// WEBPACK FOOTER //
// ./test/it/lib/LineView.js